export default "__VITE_ASSET__CZM_Ogzf__"